export const pagamentoStatusTradimus = {
  valoresDivergentes: 'Valores Divergentes',
  identificado: 'Identificado',
  conciliacaoAutomaticaTradimus: 'Conciliação Automática Tradimus',
  conciliacaoManualTradimus: 'Conciliação Manual Tradimus',
  publicacaoPendente: 'Publicação Pendente',
}
